/**
 * Enum-like object containing keys for supported statistic types.
 *
 * These keys map to string identifiers used in backend requests or conditional logic.
 */
export const Statistic = {
    AutoAnalysisStatistics: "auto-analysis-statistics",
    SelfEsteemStatistics: "self-esteem-statistics",
    YourDevelopmentGoalStatistics: "your-development-goal-statistics",
    YourSecondDevelopmentGoalStatistics: "your-second-development-goal-statistics",
    ClientAgreementStatistics: "client-agreement-statistics",
    ClientSecondAgreementStatistics: "client-second-agreement-statistics",
}
